import React, { memo } from "react";
import { TableColumns } from "./Table";

type TableTotalsType<T> = {
  columns: TableColumns<T>[];
  getAlignmentClass?: (align?: "Left" | "Center" | "Right") => string;
};

const TableTotals = <T,>({
  columns,
  getAlignmentClass
}: TableTotalsType<T>) => {
  let totalColumnsCount = 0;
  const totalColumns: React.JSX.Element[] = columns.map((col, index) => {
    let value = col.total;
    if (value) {
      totalColumnsCount++;
    }

    if (index === 0 && !col.total) {
      value = "Total:";
    }

    const columnKey =
      col.dataName?.toString() ??
      col.dataNameJSX?.toString() ??
      col.caption ??
      col.className ??
      `column-${index}`;

    return (
      <td
        className={[
          "Total",
          "font-bold border-b-0",
          getAlignmentClass?.(col.align) ?? "text-left",
          col.className ?? ""
        ]
          .filter(Boolean)
          .join(" ")}
        key={`total-${columnKey}`}
      >
        <div className="TableCell-Content table-cell-content">
          <span>{value}</span>
        </div>
      </td>
    );
  });

  if (totalColumnsCount === 0) {
    return null;
  }

  return (
    <tr className="Totals">
      <td className="td-Padding w-panel-padding border-b-0" />
      {totalColumns}
      <td className="td-Padding w-panel-padding border-b-0" />
    </tr>
  );
};

export default memo(TableTotals) as typeof TableTotals;
